/* -- THE BEAUTY CLINIC CLUB - theme.js -- */

/* -- AJAX ADD TO CART -- */
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.add-to-bag');
  if (!btn) return;

  const variantId = btn.dataset.variantId;
  const productTitle = btn.dataset.productTitle || 'Product';

  if (!variantId) {
    console.warn('No variant ID found on button');
    return;
  }

  btn.disabled = true;
  btn.textContent = 'Adding…';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(res => {
      if (!res.ok) throw new Error('Cart error');
      return res.json();
    })
    .then(() => {
      updateCartCount();
      showToast(productTitle);
      btn.textContent = 'Added ✦';
      setTimeout(() => {
        btn.disabled = false;
        btn.textContent = 'Add to Bag';
      }, 2000);
    })
    .catch(() => {
      btn.disabled = false;
      btn.textContent = 'Add to Bag';
      showToast('Something went wrong. Please try again.', true);
    });
});

/* -- UPDATE CART COUNT -- */
function updateCartCount() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const count = cart.item_count;
      const el = document.getElementById('cartCount');
      if (!el) return;
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-flex' : 'none';
    });
}

/* -- TOAST NOTIFICATION -- */
function showToast(message, isError) {
  const toast = document.getElementById('cart-toast');
  const msg = document.getElementById('toastMsg');
  if (!toast || !msg) return;
  msg.textContent = isError ? message : '"' + message.slice(0, 30) + (message.length > 30 ? '…' : '') + '" added to bag';
  toast.classList.add('show');
  clearTimeout(window._toastTimer);
  window._toastTimer = setTimeout(() => toast.classList.remove('show'), 3000);
}

/* -- PRODUCT FILTER TABS -- */
const filterBtns = document.querySelectorAll('.filter-btn');
filterBtns.forEach(btn => {
  btn.addEventListener('click', function () {
    filterBtns.forEach(b => {
      b.classList.remove('active');
      b.setAttribute('aria-selected', 'false');
    });
    this.classList.add('active');
    this.setAttribute('aria-selected', 'true');

    const filter = this.dataset.filter;
    const cards = document.querySelectorAll('.product-card');
    cards.forEach(card => {
      if (filter === 'all' || card.dataset.filter === filter) {
        card.style.display = '';
      } else {
        card.style.display = 'none';
      }
    });
  });
});

/* -- INIT CART COUNT ON LOAD -- */
updateCartCount();

/* ============================================================
   3D EXPERIENCE - Phase 1
   Desktop (fine pointer): mouse tilt + gold glare, mouse
   parallax hero. Mobile/touch: scroll-driven card tilt and
   scroll parallax hero, so the 3D feel matches the web version.
   Shared: scroll depth reveals, floating gold motes.
   The featured video panel is deliberately untouched.
   Respects prefers-reduced-motion.
   ============================================================ */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var finePointer = window.matchMedia('(pointer: fine)').matches;

  /* -- Scroll depth reveals (all devices) -- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        el.classList.add('is-in');
        io.unobserve(el);
        el.addEventListener('transitionend', function handler() {
          el.classList.remove('reveal-3d', 'is-in');
          el.style.transitionDelay = '';
          el.removeEventListener('transitionend', handler);
        });
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    document.querySelectorAll('.product-card, .pro-card, .cart-item').forEach(function (card, i) {
      card.classList.add('reveal-3d');
      card.style.transitionDelay = (i % 4) * 70 + 'ms';
      io.observe(card);
    });

    document.querySelectorAll('#main-content .shopify-section').forEach(function (sec) {
      if (sec.querySelector('.hero') || sec.querySelector('.product-card')) return;
      sec.classList.add('reveal-3d');
      io.observe(sec);
    });
  }

  /* -- Hero elements + floating gold motes (all devices) -- */
  var hero = document.querySelector('.hero');
  var heroLeft = document.querySelector('.hero-left');
  var plxEls = [];
  if (heroLeft) {
    var sels = ['.hero-eyebrow', '.hero-title', '.hero-sub', '.hero-cta-group'];
    var depths = [10, 18, 12, 9];
    sels.forEach(function (sel, i) {
      var el = heroLeft.querySelector(sel);
      if (el) plxEls.push({ el: el, depth: depths[i] });
    });

    for (var m = 0; m < 6; m++) {
      var mote = document.createElement('span');
      mote.className = 'gold-mote';
      mote.setAttribute('aria-hidden', 'true');
      var size = 3 + Math.random() * 4;
      mote.style.width = size + 'px';
      mote.style.height = size + 'px';
      mote.style.left = (8 + Math.random() * 80) + '%';
      mote.style.bottom = (10 + Math.random() * 55) + '%';
      mote.style.animationDuration = (7 + Math.random() * 8) + 's';
      mote.style.animationDelay = (Math.random() * 6) + 's';
      heroLeft.appendChild(mote);
    }
  }

  if (finePointer) {
    /* -- Desktop: 3D tilt cards + gold glare -- */
    document.querySelectorAll('.product-card, .pro-card').forEach(function (card) {
      var glare = document.createElement('span');
      glare.className = 'card-glare';
      glare.setAttribute('aria-hidden', 'true');
      card.appendChild(glare);

      card.addEventListener('mouseenter', function () {
        card.style.transition = 'transform 0.12s ease-out';
      });
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform =
          'perspective(900px) rotateX(' + (y * -6).toFixed(2) + 'deg) rotateY(' + (x * 7).toFixed(2) + 'deg) translateY(-4px)';
        card.style.setProperty('--gx', ((x + 0.5) * 100).toFixed(1) + '%');
        card.style.setProperty('--gy', ((y + 0.5) * 100).toFixed(1) + '%');
      });
      card.addEventListener('mouseleave', function () {
        card.style.transition = 'transform 0.45s ease';
        card.style.transform = '';
      });
    });

    /* -- Desktop: hero mouse parallax -- */
    if (hero && plxEls.length) {
      var tx = 0, ty = 0, cx = 0, cy = 0, raf = null;
      var tick = function () {
        cx += (tx - cx) * 0.08;
        cy += (ty - cy) * 0.08;
        plxEls.forEach(function (p) {
          p.el.style.transform =
            'translate3d(' + (cx * p.depth).toFixed(2) + 'px,' + (cy * p.depth).toFixed(2) + 'px,0)';
        });
        if (Math.abs(tx - cx) > 0.001 || Math.abs(ty - cy) > 0.001) {
          raf = requestAnimationFrame(tick);
        } else {
          raf = null;
        }
      };
      hero.addEventListener('mousemove', function (e) {
        var r = hero.getBoundingClientRect();
        tx = (e.clientX - r.left) / r.width - 0.5;
        ty = (e.clientY - r.top) / r.height - 0.5;
        if (!raf) raf = requestAnimationFrame(tick);
      });
      hero.addEventListener('mouseleave', function () {
        tx = 0;
        ty = 0;
        if (!raf) raf = requestAnimationFrame(tick);
      });
    }
  } else {
    /* -- Mobile/touch: scroll-driven 3D -- */
    var cards = Array.prototype.slice.call(document.querySelectorAll('.product-card, .pro-card'));
    var ticking = false;

    var mobileTick = function () {
      var vh = window.innerHeight;
      cards.forEach(function (card) {
        if (card.classList.contains('reveal-3d')) return;
        var r = card.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) {
          if (card.style.transform) card.style.transform = '';
          return;
        }
        var d = (r.top + r.height / 2 - vh / 2) / (vh / 2);
        d = Math.max(-1, Math.min(1, d));
        card.style.transition = 'none';
        card.style.transform = 'perspective(900px) rotateX(' + (d * 4).toFixed(2) + 'deg)';
      });
      var y = window.scrollY || window.pageYOffset || 0;
      if (y < window.innerHeight * 1.5) {
        plxEls.forEach(function (p) {
          p.el.style.transform = 'translate3d(0,' + (y * p.depth * -0.012).toFixed(2) + 'px,0)';
        });
      }
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(mobileTick);
      }
    }, { passive: true });
    mobileTick();
  }
})();
